import React from 'react';
import SearchModel from 'components/organisms/SearchModal';

const SearchPage = (): React.JSX.Element => {
  return (
    <div className="search-page">
      <SearchModel />
    </div>
  );
};

export default SearchPage;